import { property, subclass } from '@arcgis/core/core/accessorSupport/decorators';
import { messageBundle, tsx } from '@arcgis/core/widgets/support/widget';
import Widget from '@arcgis/core/widgets/Widget';
import { VNode } from 'src/interfaces/interfaces';

import t9nAppMessages from "../../t9n/App/App.json";
import "./InfoBadge/InfoBadge.scss";

@subclass('Landing.widgets.InfoBadge')
export default class InfoBadge extends Widget {
  @property()
  badge: string;

  @property()
  @messageBundle("dist/assets/t9n/App/App")
  appMessages: typeof t9nAppMessages;

  constructor(props){
    super(props);
  }

  render() {
    return (
      <calcite-chip
        scale="s"
        appearance="solid"
        class={this.classes("badge", `badge--${this.badge}`)}>
        {this.appMessages.appBadges[this.badge]}
      </calcite-chip>
    )
  }
}